import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import { RESULT_PAYMENT } from 'shared/api/check-payment'
import SuccessImage from 'shared/images/avia-success.png'
import { Button } from 'shared/ui/button'

import { AviaError } from './components/avia-error'
import { AviaPending } from './components/avia-pending'
import styles from './styles.module.scss'

type Props = {
  status: RESULT_PAYMENT
}

export const AviaSuccess = ({ status }: Props) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const onClick = () => {
    navigate(RoutingPaths.myOrders.path())
  }

  if (status === RESULT_PAYMENT.CANCELLED) {
    return <AviaError onClick={onClick} />
  }

  if (status === RESULT_PAYMENT.SUCCESS) {
    return (
      <div
        className={clsx('container', 'safe-area-top-padding', styles.container)}
      >
        <div className={styles.content}>
          <img
            alt=""
            src={SuccessImage}
            className={styles.successImage}
          />

          <div className={styles.text}>
            <h3 className={styles.title}>{t('congrats')}</h3>
            <p className={clsx(styles.description, 'medium-16')}>
              {t('avia_success.success_description')}
            </p>
          </div>

          <div className={styles.btnContainer}>
            <Button
              variant="grey"
              onClick={onClick}
            >
              <span className={clsx(styles.buttonText, 'bold-16')}>
                {t('my_tickets')}
              </span>
            </Button>
          </div>
        </div>
      </div>
    )
  }

  return <AviaPending onClick={onClick} />
}
